import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Utilities.frontend.types'

@Injectable({ providedIn: 'root' })
export class Utilities_get_awi_configurations_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { context: string, filters: { material_id?: number, account_id?: number, project_id?: number, owner_id?: number, warehouse_id?: number, order_class_id?: number, material_group_id?: number }, allow_inherited_configs?: boolean, scope: string }): Promise<{ config?: any, reasons?: string[], config_source?: any, config_id?: number, applicable_config_ids?: number[], config_filters?: { name: string, value: string }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.context)) {
      $missingRequiredInParams.push('\'context\'');
    }
    if (isNil($inParams.filters)) {
      $missingRequiredInParams.push('\'filters\'');
    }
    if (isNil($inParams.scope)) {
      $missingRequiredInParams.push('\'scope\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

